// @mui
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

export default function DisabledGPSIcon({ ...other }) {
  const theme = useTheme();
  const PRIMARY_MAIN = theme.palette.primary.main;

  return (
    <Box {...other}>
      <svg width="66" height="57" viewBox="0 0 66 57" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5.15188L7.23 0.921875L58.14 51.8319L53.91 56.0619L32.67 34.8219C27.33 34.8819 22.05 36.9519 18 41.0019L12 35.0019C15.81 31.2219 20.37 28.6719 25.23 27.3819L18.51 20.6619C13.95 22.5219 9.69 25.3119 6 29.0019L0 23.0019C3.66 19.3719 7.77 16.4919 12.15 14.3019L3 5.15188ZM66 23.0024L60 29.0024C52.47 21.4724 42.54 17.7524 32.64 17.8124L24.9 10.0724C39.39 7.55237 54.81 11.8124 66 23.0024ZM42.8401 28.0105C46.9201 29.4505 50.7601 31.7605 54.0001 35.0005L51.9001 37.0705L42.8401 28.0105ZM24 47.0023L33 56.0023L42 47.0023C37.05 42.0223 28.98 42.0223 24 47.0023Z"
          fill={PRIMARY_MAIN}
        />
      </svg>
    </Box>
  );
}
